import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=49a76214&lang=css"
import "./App.vue?vue&type=style&index=1&id=49a76214&lang=scss&scoped=true"

import exportComponent from "/Users/yangxu/work/js_celue-zuhe_src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a76214"]])

export default __exports__